import Layout from "../../components/Layout/Layout";
import DoctorSummary from "./DoctorSummary";
import AssignChart from "./AssignChart";
import { useContext, useEffect, useState } from "react";
import MuiAlert from "../../components/Alert/Alert";
import { User } from "../../store/Store";
import { isInRole } from "../../helpers/HelperFunctions";
import { useNavigate } from "react-router-dom";

import "./Home.scss";

export default function Home() {

    const [loading, setLoading] = useState(false);
    const [showAlert, setShowAlert] = useState({ isError: false, message: "", open: false });

    const [user] = useContext(User);

    const navigate = useNavigate();

    useEffect(() => {
        if (!isInRole(user?.roles, "Admin")) {
            return navigate("/dashboard/reports");
        }
    }, [user])

    return (<Layout selectedIndex={0}>
        <div className="home-container">
            <MuiAlert error={showAlert.isError} message={showAlert.message} open={showAlert.open}
                onClose={() => {
                    let newShowAlert = showAlert;
                    newShowAlert.open = false;
                    setShowAlert(prevDetails => ({ ...prevDetails, ...newShowAlert }));
                }} />
            <div className="header">
                <span className="text">Home</span>
            </div>

            <AssignChart setLoading={setLoading} setShowAlert={setShowAlert} />
            <DoctorSummary setLoading={setLoading} setShowAlert={setShowAlert} />
        </div>
    </Layout >)
}